export default __webpack_public_path__ + "static/media/mushroom-parent-and-child--back--240.98a4be74.jpg";